import VueClipboard from 'vue-clipboard2';

export default ({ Vue }) => {
  Vue.use(VueClipboard);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-clipboard2.js